// eslint-disable-next-line max-len
// <div class="detail-material-yt-with-timecodes" data-yt-video-with-timecodes='{"video":"6r-4CiV--4s","codes":[["00:00:14","Колесо ССГ – концепция для систематизации и упрощения подходов к диагностике и лечению ССГ"],["00:03:09","Профилактика и выявление факторов риска"],["00:06:28","Диагностика"],["00:12:47","Ведение пациента"],["00:15:36","Заключение"]]}' >
//   <div data-yt-video-with-timecodes-anchor></div>
// </div>
// * пример кода для вставки на стр

export class TimeCodeList {
  constructor(elements) {
    if (!elements || !elements.length) {
      return;
    }

    this.elements = elements;
    this.downloadScript();
  }

  downloadScript() {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    window.onYouTubeIframeAPIReady = this.onPlayerAPILoaded.bind(this);
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  onPlayerAPILoaded() {
    this.elements.forEach((element) => {
      try {
        const config = JSON.parse(element.dataset.ytVideoWithTimecodes);
        /* eslint-disable-next-line */
        const currentVideo = new window.YT.Player(element.querySelector('[data-yt-video-with-timecodes-anchor]'), {
          // height  : '360',
          // width   : '640',
          videoId: config.video
        });
        const ul = this.constructControls(config.codes, currentVideo);
        element.appendChild(ul);
      } catch (e) {
        console.error(e);
      }
    });
  }

  constructControls(codes, currentVideo) {
    if (!codes) {
      console.error('Не переданы таймкоды');
      return;
    }
    const ul = document.createElement('div');
    codes.forEach((el) => {
      const li = document.createElement('div');
      const span1 = document.createElement('span');
      const span2 = document.createElement('span');
      // eslint-disable-next-line prefer-destructuring
      span1.innerHTML = el[0];
      span1.style.cursor = 'pointer';
      span1.style.textDecoration = 'underline';
      // eslint-disable-next-line prefer-destructuring
      span2.innerHTML = ` ${el[1]}`;
      span1.addEventListener('click', () => {
        currentVideo.seekTo(this.convertTimeToSeconds(el[0]));
        currentVideo.playVideo();
      });
      li.appendChild(span1);
      li.appendChild(span2);
      ul.appendChild(li);
    });
    // eslint-disable-next-line consistent-return
    return ul;
  }

  convertTimeToSeconds(time) {
    const timeArray = time.split(':');
    const hours = parseInt(timeArray[0], 10) || 0;
    const minutes = parseInt(timeArray[1], 10) || 0;
    const seconds = parseInt(timeArray[2], 10) || 0;

    return (hours * 3600) + (minutes * 60) + seconds;
  }
}
